import axios from 'axios';
import apiClient from './apiClient';
import { ActivityDashboardResponse } from '../types/ActivityDashboard';

// Fjern ev. trailing slash (.env-ene har det) — ellers blir det //api/... som gir 404
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'https://localhost:7100').replace(/\/+$/, '');

// Bruker bevisst IKKE den felles apiClient: storskjermen autentiserer med egen
// visnings-nøkkel i URL-en, ikke JWT, og skal ikke trigge 401-logout/reload.
export const fetchActivityDashboard = async (key: string): Promise<ActivityDashboardResponse> => {
  const response = await axios.get<ActivityDashboardResponse>(
    `${API_BASE_URL}/api/activitydashboard`,
    { params: { key } }
  );
  return response.data;
};

// For innloggede admins: hent visnings-nøkkelen slik at UI-et kan lenke til /storskjerm
export const fetchDashboardKey = async (): Promise<string> => {
  const response = await apiClient.get<{ key: string }>('/api/activitydashboard/link');
  return response.data.key;
};